<template>
  <div class="actor_message_confirm">
    <p class="text_left actor_message_confirm_text actor_message_text">{{ form.text }}</p>
    <p class="text_left highlight_yellow actor_message_confirm_text actor_message_text">上記の内容でよろしければ、[送信]ボタンを押して下さい。</p>
    <p>
      <button
        type="submit"
        class="btn arrow"
        :disabled="isSend"
        @click.prevent="send"
      >送信</button>
    </p>
  </div>
</template>

<script>
import { POST_MESSAGE_BY_SETTING } from '@/store/message/actions'
import { ERROR_MESSAGE_BAD_REQUEST } from '@/common/messages'

export default {
  name: 'ActorMessageConfirmBySetting',
  props: {
    form: Object
  },
  data () {
    return {
      id: this.$route.params.id,
      settingId: this.$route.params.settingId,
      isSend: false
    }
  },
  methods: {
    send () {
      if (this.isSend) return
      this.isSend = true

      this.$store.dispatch(POST_MESSAGE_BY_SETTING, {
        id: this.id,
        settingId: this.settingId,
        params: {
          text: this.form.text
        }
      })
        .then((data) => {
          this.form.text = ''
          this.$emit('input', this.form)
          this.$router.pushIsses({ name: 'ActorMessageCompleteBySetting' })
        })
        .catch((error) => {
          this.isSend = false
          this.form.errors = []

          let message = ERROR_MESSAGE_BAD_REQUEST
          if (error.errorStatus === 400) {
            message = message + '\n' + error.message
          } else if (error.errors === 402) {
            this.$router.pushIsses({ name: 'UserPointShortage' })
          } else {
            message = error.message
          }

          this.form.errors.push(message)
          this.$emit('input', this.form)
          this.$router.pushIsses({ name: 'ActorMessageBySetting' })
        })
    }
  },
  created () {
    if (this.form.text.length === 0) {
      this.$router.go(-1)
    }
  }
}
</script>
